import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  welcomeContent: css`
    padding: 16px 8px !important;
    margin-top: 16px !important;
    border-radius: 10px !important;
    p {
      margin-bottom: 0px;
    }
    &.MuiPaper-elevation {
      box-shadow: none;
    }
  `,
  flexRow: css`
    display: flex;
    flex-direction: row;
  `,
  flexColumn: css`
    display: flex;
    flex-direction: column;
  `,
  iconDefault: css`
    float: left;
    margin-right: 8px !important;
    /* @media (max-width: 480px) {
      display: none;
    } */
  `,
  iconWarning: css`
    float: left;
    margin-right: 8px !important;
  `,
  ctasContainer: css`
    padding-top: 4px;
    display: flex;
    flex-direction: column;
    @media (max-width: 480px) {
      padding-left: 0px;
    }
  `,
  ctas: css`
    margin-top: 8px;
  `,
  variants: {
    default: css`
      background-color: #f0f2f6 !important;
      p {
        color: #2d344b;
        font-size: 16px;
      }
    `,
    pop: css`
      background-color: #f0f8f2 !important;
      border: 1px solid ${colors.jungle300};
    `,
    warning: css`
      background-color: #fffae5 !important;
      border: 1px solid ${colors.peach200};
      p {
        span {
          color: #333b56 !important;
          font-size: 13px;
        }
      }
    `,
    prussian: css`
      background-color: #576183 !important;
      p {
        color: ${colors.white} !important;
        font-size: 1rem;
        line-height: 1.5;
        span {
          color: ${colors.white} !important;
        }
      }
    `,
  },
  footer: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

export default styles;
